
import React from 'react';
import { Button } from "@/components/ui/button";
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { formatCurrency, formatDate } from '../../utils';

interface RepaymentsTableProps {
  repayments: any[];
  onViewDetails: (repayment: any) => void;
}

export const RepaymentsTable: React.FC<RepaymentsTableProps> = ({ 
  repayments,
  onViewDetails
}) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Due Date</TableHead>
          <TableHead>Borrowing</TableHead>
          <TableHead className="text-right">Principal</TableHead>
          <TableHead className="text-right">Interest</TableHead>
          <TableHead className="text-right">Total</TableHead>
          <TableHead>Status</TableHead>
          <TableHead className="text-right">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {repayments.length > 0 ? (
          repayments.map((repayment: any, idx: number) => (
            <TableRow key={idx} className="group">
              <TableCell>{formatDate(repayment.date)}</TableCell>
              <TableCell className="font-medium">{repayment.borrowingName || 'Term Loan'}</TableCell>
              <TableCell className="text-right">{formatCurrency(repayment.principal)}</TableCell>
              <TableCell className="text-right">{formatCurrency(repayment.interest)}</TableCell>
              <TableCell className="font-medium text-right">{formatCurrency(repayment.total)}</TableCell>
              <TableCell>
                <Badge 
                  variant={repayment.status === 'Paid' ? 'outline' : 
                          repayment.status === 'Overdue' ? 'destructive' : 'secondary'}
                >
                  {repayment.status}
                </Badge>
              </TableCell>
              <TableCell className="text-right">
                <Button 
                  size="sm" 
                  variant="outline"
                  onClick={() => onViewDetails(repayment)}
                  className="opacity-70 group-hover:opacity-100"
                >
                  View Details
                </Button>
              </TableCell>
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={7} className="text-center py-6 text-muted-foreground">
              No repayments found matching your filters
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
};
